export default __webpack_public_path__ + "static/top-shadow-450ba38a19353ae3a05283f872208bab.png";